var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkInVolunteerFunctionDef, checkOutVolunteerFunctionDef, } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
export const useCheckInCheckoutActions = () => {
    const { t } = useMissionsTranslation();
    const checkInVolunteerPlatformFn = useTypedPlatformFunction(checkInVolunteerFunctionDef);
    const checkOutVolunteerPlatformFn = useTypedPlatformFunction(checkOutVolunteerFunctionDef);
    const handleCheckInVolunteer = (params) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield checkInVolunteerPlatformFn(params);
            showAlertSnackbar({
                message: t('shifts.ongoingShifts.snackbar.checkedIn'),
                autoHideDuration: 2000,
                type: 'success',
            });
        }
        catch (error) {
            return handleErrorDialog(error);
        }
    });
    const handleCheckOutVolunteer = (params) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield checkOutVolunteerPlatformFn(params);
            showAlertSnackbar({
                message: t('shifts.ongoingShifts.snackbar.checkedOut'),
                autoHideDuration: 2000,
                type: 'success',
            });
        }
        catch (error) {
            return handleErrorDialog(error);
        }
    });
    return {
        handleCheckInVolunteer,
        handleCheckOutVolunteer,
    };
};
